define('app/collections/travel_train_collection',['app/setup','app/models/travel_ticket_model'], function(takhfifan, ticketModel) {

  takhfifan.TravelTrainCollection = Backbone.Collection.extend({
    model : takhfifan.TravelTicket,
    url: '/ajax/productlist/gettraintickets',
    stationsModel : [],
    trainsModel : [],
    tickets: [],
    priceModel: null,
    coupePriceModel: null,
    optionalServices: null,
    parse : function(response, options) {
      var models = [];
      _.each(response.departure, function (departureItem) {
        if (response.returnItems && !_.isEmpty(response.returnItems)) {
          _.each(response.returnItems, function (returnItem) {
            models.push({
              capacity : departureItem.capacity + " , " + returnItem.capacity,
              departureCapacity : departureItem.capacity,
              returnCapacity : returnItem.capacity,
              totalPrice: parseInt(departureItem.price,10)+parseInt(returnItem.price,10),
              totalRetailPrice: parseInt(departureItem.retailPrice,10)+parseInt(returnItem.retailPrice,10),
              date: parseInt(departureItem.seconds,10)+parseInt(returnItem.seconds,10),
              departure: departureItem,
              returnData: returnItem,
              departureDate: departureItem.date,
              returnDate: returnItem.date
            });
          });
        } else {
          models.push({
            totalPrice: parseInt(departureItem.price,10),
            totalRetailPrice: parseInt(departureItem.retailPrice,10),
            capacity : departureItem.capacity,
            date: departureItem.seconds,
            departure: departureItem,
            departureDate: departureItem.date
          })
        }
      });

      return models;
    },

    fetchStations: function (options) {
      this.fetchCallback = options.success;
      this.getStationsModels({url: '/v4/api/train/get-stations'});
    },
    getStationsModels: function(options){
      var _this = this;
      $.ajax(options).done(function (data, textStatus, jqXHR) {
        if (jqXHR.status == 204) {
          _this.getStationsModels.call(_this, options);
        } else {
          if(textStatus==="success"){
            _this.processStationsResults(data || []);
          }
        }
      }).fail(function (e) {
        console.error("get stations failed: ", e);
      }).always(function () {
      });
    },
    processStationsResults: function (results) {
      this.stationsModel = results;
      this.fetchCallback(this);
    },

    search: function (options) {
      var url = '/v4/api/train/search' +
        '?origin=' + options.data.origin +
        '&destination=' + options.data.destination +
        '&date=' + options.data.date +
        '&ticket_type=' + options.data.ticket_type;

      this.fetchCallback = options.success;
      this.getTrainsModels({url: url}, options.data.is2Way, options.data.travel_type);
    },
    getTrainsModels: function (options, is2Way, travel_type) {
      var _this = this;
      $.ajax(options).done(function (data, textStatus, jqXHR) {
        if (jqXHR.status == 204) {
          _this.getTrainsModels.call(_this, options, is2Way, travel_type);
        } else {
          if(textStatus==="success"){
            _this.processTrainsResults(data || [], is2Way, travel_type);
          }
        }
      }).fail(function (e) {
        console.error("get stations failed: ", e);
      }).always(function () {
      });
    },
    processTrainsResults: function (results, is2Way, travel_type) {
      var _this = this;
      var tmpModels = [];
      _.each(results, function (result) {
        var model = {
          fromCompany:'raja',
          avaliable_sell_count: result.avaliable_sell_count,
          circular_number_serial: result.circular_number_serial,
          circular_period: result.circular_period,
          compartment_capicity: result.compartment_capicity,
          cost: result.cost,
          counting: result.counting,
          counting_all: result.counting_all,
          degree: result.degree,
          exit_date: result.exit_date,
          exit_datetime: result.exit_datetime,
          exit_time: _this.formatDateTime(result.exit_time),
          full_price: result.full_price,
          is_compartment: result.is_compartment,
          move_date: result.move_date,
          owner: result.owner,
          path_code: result.path_code,
          rate_code: result.rate_code,
          ration_code: result.ration_code,
          remain: result.remain,
          ret_status: result.ret_status,
          seat_type: result.seat_type,
          sold_count:result.sold_count,
          soldcounting: result.soldcounting,
          time_of_arrival:result.time_of_arrival,
          train_number:result.train_number,
          wagon_name: result.wagon_name,
          wagon_type: result.wagon_type,
          facilities:{
            media: result.media,
            air_conditioning: result.air_conditioning
          },
          travel_type: travel_type
        };
        tmpModels.push(model);
      });

      this.trainsModel = tmpModels;
      this.fetchCallback(this);
    },

    fetchCoupePrice: function (options) {
      var url = '/v4/api/train/prices' +
        '?rate_code=' + options.data.ticket.rate_code +
        '&path_code=' + options.data.ticket.path_code +
        '&origin=' + options.data.ticket.origin +
        '&destination=' + options.data.ticket.destination +
        '&wagon_type=' + options.data.ticket.wagon_type +
        '&departing_time=' + options.data.ticket.exit_datetime +
        '&train_number=' + options.data.ticket.train_number +
        '&circular_number_serial=' + options.data.ticket.circular_number_serial +
        '&sold_count=' + options.data.ticket.sold_count +
        '&ration_code=' + options.data.ticket.ration_code +
        '&compartment_capacity=' + options.data.ticket.compartment_capicity +
        '&adult=' + options.data.ticket.adult +
        '&child=' + options.data.ticket.child +
        '&charter=' + options.data.ticket.charter;

      this.fetchCallback = options.success;
      this.getCoupePriceModel({url: url});
    },
    getCoupePriceModel: function(options){
      var _this = this;
      $.ajax(options).done(function (data, textStatus, jqXHR) {
        if (jqXHR.status == 204) {
          _this.getCoupePriceModel.call(_this, options);
        } else {
          if(textStatus==="success"){
            _this.processCoupePriceResults(data || []);
          }
        }
      }).fail(function (e) {
        console.error("get stations failed: ", e);
      }).always(function () {
      });
    },
    processCoupePriceResults: function (result) {
      this.coupePriceModel = result;
      this.fetchCallback(this);
    },

    fetchOptionalServices: function (options) {
      var departing_time = options.data.ticket.exit_datetime.split('+');

      var url = '/v4/api/train/optional-services' +
        '?wagon_type=' + options.data.ticket.wagon_type +
        '&departing_time=' + departing_time[0] +
        '&train_number=' + options.data.ticket.train_number +
        '&circular_number_serial=' + options.data.ticket.circular_number_serial +
        '&circular_period=' + options.data.ticket.circular_period ;

      this.fetchCallback = options.success;
      this.getOptionalServicesModel({url: url});
    },
    getOptionalServicesModel: function(options){
      var _this = this;
      $.ajax(options).done(function (data, textStatus, jqXHR) {
        if (jqXHR.status == 204) {
          _this.getOptionalServicesModel.call(_this, options);
        } else {
          if(textStatus==="success"){
            _this.processOptionalServicesResults(data || []);
          }
        }
      }).fail(function (e) {
        console.error("get stations failed: ", e);
      }).always(function () {
      });
    },
    processOptionalServicesResults: function (result) {
      this.optionalServices = result;
      this.fetchCallback(this);
    },

    fetchPrice: function (options) {

      var url = '/v4/api/train/get-price' +
        '?rate_code=' + options.data.ticket.rate_code +
        '&price_group=' + options.data.price_group +
        '&path_code=' + options.data.ticket.path_code +
        '&origin=' + options.data.ticket.origin +
        '&destination=' + options.data.ticket.destination +
        '&wagon_type=' + options.data.ticket.wagon_type +
        '&departing_time=' + options.data.ticket.exit_datetime +
        '&train_number=' + options.data.ticket.train_number +
        '&circular_number_serial=' + options.data.ticket.circular_number_serial +
        '&sold_count=' + options.data.ticket.sold_count +
        '&ration_code=' + options.data.ticket.ration_code;

      this.fetchCallback = options.success;
      this.getPriceModel({url: url});
    },
    getPriceModel: function(options){
      var _this = this;
      $.ajax(options).done(function (data, textStatus, jqXHR) {
        if (jqXHR.status == 204) {
          _this.getPriceModel.call(_this, options);
        } else {
          if(textStatus==="success"){
            _this.processPriceResults(data || []);
          }
        }
      }).fail(function (e) {
        console.error("get stations failed: ", e);
      }).always(function () {
      });
    },
    processPriceResults: function (result) {
      this.priceModel = result;
      this.fetchCallback(this);
    },

    formatDateTime:function (datetime) {
      return (datetime.split(/[T.]/)[1]).substr(0, 5);
    }
  });

});

